import { graphql, useStaticQuery } from 'gatsby';
import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';

import { IMeetingPlaceLinkToAnyPage } from '../queries/fragments/meetingPlaceLinkToAnyPage';

export interface INewsletterFormData {
  id: string;
  additionalBlocks: IAdditionalBlocks;
  newsletterSubscriptionTitle: string;
  termsAndConditionsCheckboxLabel: {
    termsAndConditionsCheckboxLabel: string;
  };
  termsAndConditionsCheckboxLabelLink: string;
  termsAndConditionsPageLink: IMeetingPlaceLinkToAnyPage;
  metadata: {
    tags: tags[];
  };
  node_locale: string;
}

export interface IAdditionalBlocks {
  descriptionText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  emailFieldErrorMessage?: string;
  emailFieldLabel: string;
  emailFieldPlaceholder: string;
  emailValidationFieldErrorMessage?: string;
  emailValidationFieldLabel: string;
  emailValidationFieldPlaceholder: string;
  nameFieldErrorMessage?: string;
  nameFieldLabel: string;
  nameFieldPlaceholder: string;
  subscribeButtonLabel: string;
  subscribeErrorTitle: string;
  subscribeErrorMessage: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  genericErrorReloadButtonLabel?: string;
  closeButtonLabel: string;
  unsubscribeTitle: string;
  newsletterSubscriptionTitle: string;
  unsubscribeErrorTitle: string;
  unsubscribeErrorMessage: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  unsubscribeDescription1: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  unsubscribeDescription2: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  subscriptionEmailConfirmationModalTitle: string;
  subscriptionEmailConfirmationModalDescription: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  emailAlreadyExistTitle: string;
  emailAlreadyExistDescription: RenderRichTextData<ContentfulRichTextGatsbyReference>;
}

type tags = {
  contentful_id: string;
};

export const useGetNewsletterFormData = (
  locale: string,
): INewsletterFormData => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulLibraryPopupModal {
          blocktype: __typename
          nodes {
            node_locale
            metadata {
              tags {
                contentful_id
              }
            }
            name
            newsletterSubscriptionTitle
            termsAndConditionsCheckboxLabel {
              termsAndConditionsCheckboxLabel
            }
            termsAndConditionsCheckboxLabelLink
            termsAndConditionsPageLink {
              ...MeetingPlaceLinkToAnyPage
            }
            additionalBlocks {
              ...blockNewsletterData
            }
          }
        }
      }
    `,
  );
  const filteredData = data.allContentfulLibraryPopupModal.nodes.find(
    (newsletter: INewsletterFormData) => {
      return (
        newsletter.metadata.tags.find(
          (tag: tags) =>
            tag.contentful_id === process.env.MEETINGPLACE_TAG_CONTENTFUL_ID ||
            tag.contentful_id ===
              process.env.GATSBY_MEETINGPLACE_TAG_CONTENTFUL_ID,
        ) && newsletter.node_locale === locale
      );
    },
  );
  return filteredData;
};

export const query = graphql`
  fragment blockNewsletterData on ContentfulBlockNewsletter {
    node_locale
    descriptionText {
      raw
    }
    emailFieldErrorMessage
    emailFieldLabel
    emailFieldPlaceholder
    emailValidationFieldErrorMessage
    emailValidationFieldLabel
    emailValidationFieldPlaceholder
    id
    nameFieldErrorMessage
    nameFieldLabel
    nameFieldPlaceholder
    subscribeButtonLabel
    closeButtonLabel
    subscribeErrorTitle
    subscribeErrorMessage {
      raw
    }
    genericErrorReloadButtonLabel
    unsubscribeTitle
    unsubscribeErrorTitle
    unsubscribeErrorMessage {
      raw
    }
    unsubscribeDescription1 {
      raw
    }
    unsubscribeDescription2 {
      raw
    }
    subscriptionEmailConfirmationModalTitle
    subscriptionEmailConfirmationModalDescription {
      raw
    }
    emailAlreadyExistTitle
    emailAlreadyExistDescription {
      raw
    }
  }
`;
